<ion-header>

  <ion-toolbar>

    <ion-buttons slot="start">

      <ion-button class="ion-hide-md-up" (click)="onMenuClick($event)">
        <ion-icon slot="icon-only" name="menu-outline"></ion-icon>
      </ion-button>

    </ion-buttons>

    <ion-title>

      <ion-grid>

        <ion-row>

          <ion-col size="8" size-sm>

            <img class="logo" src="assets/img/logo-4.png" alt="Logo">
            <span class="m-2 title">Smart<span class="dine">Dine</span></span>

          </ion-col>

          <ion-col *ngIf="customLogoLocation" size="4" size-sm >
            <img class="logo" src="{{customLogoLocation}}" alt="Logo" style="margin-left: 5px;">

          </ion-col> 

        </ion-row>
      </ion-grid>
      
    </ion-title>

    <div slot="end" *ngIf="logoUrl && userProfile?.roles.includes('RestaurantAdmins')">
      <img [src]="logoUrl" alt="LOGO" class="img-fluid w-150px mx-2 py-2 max-h-75px">
    </div>

   <!-- <div slot="end" *ngIf="userProfile" class="me-2">
      <ion-select class="language-chooser" [(ngModel)]="selectedLanguage" (ionChange)="onLanguageChange()">
        <ion-select-option *ngFor="let langulage of languages" [value]="langulage.code"
          [innerText]="langulage.name"></ion-select-option>
      </ion-select>
    </div> -->

    <ion-buttons slot="end" class="mx-2">

      <ion-button *ngIf="userProfile" fill="outline" class="ion-text-capitalize live-kitchen-btn" (click)="onLiveKitchenClick()">
        <ion-icon slot="start" name="desktop-outline"></ion-icon> Live Kitchen
      </ion-button>

      <ion-button *ngIf="userProfile" class="btn-notification" (click)="openNotifications($event)">
        <ion-icon slot="icon-only" name="notifications-outline" class="notify-icon"></ion-icon>
        <ion-badge slot="start" class="notify-badge">{{notificationCount}}</ion-badge>
      </ion-button>

      <ion-button (click)="openHelpAndSupport($event)" *ngIf="userProfile && userProfile.roles.includes('RestaurantAdmins')">
        <ion-icon slot="icon-only" name="help-circle-outline"></ion-icon>
      </ion-button>

      <ion-button (click)="openProfilePopover($event)" *ngIf="userProfile">
        <ion-icon slot="icon-only" name="person-circle-outline"></ion-icon>
      </ion-button>  

      <ion-button *ngIf="!userProfile" href="/login" class="mx-0">Sign In
        <ion-icon slot="start" name="log-in-outline" class="ms-0 me-1"></ion-icon>
      </ion-button>

      <ion-button *ngIf="!userProfile" href="/sign-up" class="mx-0">Sign up
        <ion-icon slot="start" name="person-add-outline" class="ms-0 me-1"></ion-icon>
      </ion-button>

    </ion-buttons>

  </ion-toolbar>

</ion-header>
